import Paper from "@mui/material/Paper";
import { Grid } from "@mui/material";

import {
  HeaderContainer,
  HeaderToolbar,
  LogoImg,
  LogoLink,
} from "../../styles/styles";
import { flexAlignCentre } from "../../../styles/mui/styles/display";
import { tangoLogo } from "../../../constants/ImagePaths";

const Header: React.FC = () => {
  return (
    <Paper elevation={3} sx={{ position: "relative", zIndex: 5 }}>
      <HeaderToolbar disableGutters>
        <Grid container sx={HeaderContainer}>
          <Grid size={12}>
            <Grid sx={flexAlignCentre} size={12}>
              <LogoLink to="/">
                <LogoImg sizes="small" alt="Pronet 2.0 Logo" src={tangoLogo} />
              </LogoLink>
            </Grid>
          </Grid>
        </Grid>
      </HeaderToolbar>
    </Paper>
  );
};

export default Header;
